import { DialogStyles } from "components/Styled";
import { FullScreenDialog } from "components/common/Modal";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import { GrayTextLink } from "../components/common/Modal";
import { modalActions } from "../modules/modal";
import { Popup } from "../styles";
import { replaceBr } from "../utility";

import type { ErrorModalData } from "../modules/modal";
import type { Store } from "../store";
import type { WithTranslation } from "react-i18next";
import type { Dispatch } from "redux";

type Props = {
  isOpen: boolean;
  errorModalData: ErrorModalData;
  toggleError: () => void;
} & WithTranslation;

class Error extends Component<Props> {
  closeModal = () => {
    this.props.toggleError();
  };
  render() {
    const { isOpen, errorModalData, t } = this.props;
    if (!isOpen) {
      return <></>;
    }

    return (
      <FullScreenDialog
        open={isOpen}
        style={DialogStyles}
        onBackdropClick={this.closeModal}
      >
        <Popup>
          <h2>{replaceBr(errorModalData.caption) || "Error"}</h2>
          <p className="popup_message" style={{ whiteSpace: "pre-line" }}>
            {replaceBr(errorModalData.msg)}
          </p>
          <GrayTextLink
            onClick={this.closeModal}
            text={t("login.buttons.close")}
          />
        </Popup>
      </FullScreenDialog>
    );
  }
}

const mapStateToProps = (state: Store) => {
  return {
    isOpen: state.modal.isOpenError,
    errorModalData: state.modal.errorModalData,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    toggleError: () => {
      dispatch(modalActions.toggleError({}));
    },
  };
};

const TransError = withTranslation()(Error);

export default connect(mapStateToProps, mapDispatchToProps)(TransError);
